import React from "react";
import {Form} from 'rsuite';

import './textContent.scss';


const  TextContent= ({cardIndex,name, style,type,options,getAnswerValueByName,updateAnswer,defaultValue}) => {
    return (
        <div className={`${style?style:''}`}>
            <Form
                name={name}>
                {options.map((option, optionIndex) => {
                    return (
                        <Form.Group
                            controlId={option.name}
                            className="d-block tac"
                            key={`${cardIndex}-${optionIndex}`}>
                            <Form.ControlLabel className="tac">{option.title}</Form.ControlLabel>
                            <Form.Control name={option.name}
                                          className="tac"
                                          autoFocus={option.auto_focus ? option.auto_focus : false}
                                          inputMode={option.input_mode ? option.input_mode : 'text'}
                                          value={getAnswerValueByName(option.name) ? getAnswerValueByName(option.name) : defaultValue}
                                          onChange={(value, event) => updateAnswer(event, type)}/>
                        </Form.Group>
                    );
                })}
            </Form>
        </div>
    );



}

export default TextContent;